import { Pay, User } from '@apis/index'
import BackNavigation from '@components/backNavigation'
import Button from '@components/button'
import PopupToast from '@components/custom-toast'
import SvgImage from '@components/svg'
import Typography from '@components/typography'
import useWindowSize from '@hooks/useWindow'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { StyleFixedButton } from '../allPages/style'
import khalti from './khalti.png'
import {
  SubscriptionAmount,
  SubscriptionCard,
  SubscriptionContainer,
  SubscriptionDateText,
  SubscriptionDetails,
  SubscriptionLabel,
  SubscriptionPaymentCard,
  SubscriptionPaymentDetails,
  SubscriptionPaymentSubtitle,
  SubscriptionPaymentTitle,
  SubscriptionPrice,
  SubscriptionRow,
  SubscriptionSectionTitle,
  SubscriptionSubtitle,
  SubscriptionSummary,
  SubscriptionTitleWrapper,
  SubscriptionTotalAmount,
  SubscriptionTotalLabel,
} from './style'

import Image from '@components/image'
import { useSelector } from 'react-redux'

const SubscriptionPage = () => {
  const navigate = useNavigate()
  const { width } = useWindowSize()
  const [searchParams] = useSearchParams()
  const transactionId = searchParams.get('transactionId')
  const { data: user } = useSelector((state: any) => state.user)
  // State to control popup display after verification
  const [isVerificationComplete, setIsVerificationComplete] = useState(false)
  const [verificationStatus, setVerificationStatus] = useState<
    'success' | 'failed' | null
  >(null)

  useEffect(() => {
    if (user?.status === 'Subscribed') {
      navigate('/books')
    }
  }, [])
  const isPopupOpen = isVerificationComplete && !!verificationStatus

  const mobile = width < 1024
  const handleClickHome = () => {
    navigate('/books', { replace: true })
  }
  const handlePay = async () => {
    const payload = { mode: 'khalti' }
    await Pay.pay(payload)
      .then(async (resp) => {
        if (resp.redirect) {
          window.location.href = resp.redirect
        }
      })
      .catch(() => {})
  }
  const verify = useCallback(async () => {
    try {
      // Extract parameters from URL
      const transactionId = searchParams.get('transactionId')
      const txnId = searchParams.get('pidx')
      const totalAmount = searchParams.get('total_amount')

      // Validate required parameters
      if (!transactionId || !txnId || !totalAmount) {
        console.error('Missing required parameters for verification:', {
          transactionId,
          txnId,
          totalAmount,
        })
        return
      }

      const payload = {
        mode: 'khalti',
        totalAmount: Number(totalAmount),
        transactionUuid: txnId,
        transactionId: Number(transactionId),
      }

      await Pay.verify(payload)
        .then(async () => {
          setVerificationStatus('success')
          await User.find('set', 'user', user?.id).then(() => {})

          setIsVerificationComplete(true)
        })
        .catch(() => {
          setVerificationStatus('failed')
          setIsVerificationComplete(true)
        })
    } catch (error) {
      console.error('Error in verify function:', error)
      setVerificationStatus('failed')
      setIsVerificationComplete(true)
    }
  }, [searchParams, user])
  useEffect(() => {
    if (!!transactionId) {
      verify()
    }
  }, [transactionId, verify])
  const todayDate = new Date()
  const formattedDate = todayDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  return (
    <>
      <BackNavigation title="Subscription" />
      <SubscriptionContainer>
        <SubscriptionDateText>{formattedDate}</SubscriptionDateText>

        <SubscriptionCard>
          <SvgImage src="rocketIcon" size={124} />
          <SubscriptionDetails>
            <SubscriptionTitleWrapper>
              <Typography
                content="Shareabook Subscription"
                weigth={500}
                size={14}
              />
            </SubscriptionTitleWrapper>

            <SubscriptionSubtitle>Expiry date: 1 year</SubscriptionSubtitle>
            <SubscriptionPrice>Rs. 500</SubscriptionPrice>
          </SubscriptionDetails>
        </SubscriptionCard>

        <SubscriptionSectionTitle weigth={400}>
          Payment Methods
        </SubscriptionSectionTitle>

        <SubscriptionPaymentCard>
          {/* <SvgImage src="khalti" /> */}
          <Image src={khalti} height={40} width={80} />
          <SubscriptionPaymentDetails>
            <SubscriptionPaymentTitle>Pay with Khalti</SubscriptionPaymentTitle>
            <SubscriptionPaymentSubtitle>Khalti </SubscriptionPaymentSubtitle>
          </SubscriptionPaymentDetails>
        </SubscriptionPaymentCard>

        {mobile ? (
          <StyleFixedButton>
            <SubscriptionSummary>
              <SubscriptionRow>
                <SubscriptionLabel>Subtotal</SubscriptionLabel>
                <SubscriptionAmount>Rs. 500</SubscriptionAmount>
              </SubscriptionRow>
              <SubscriptionRow>
                <SubscriptionTotalLabel>Total Amount</SubscriptionTotalLabel>
                <SubscriptionTotalAmount>Rs. 500</SubscriptionTotalAmount>
              </SubscriptionRow>
              <Button
                type="button"
                title="Proceed to pay"
                styleButton="width: 100%; height: 50px"
                onClick={handlePay}
              />
            </SubscriptionSummary>
          </StyleFixedButton>
        ) : (
          <SubscriptionSummary>
            <SubscriptionRow>
              <SubscriptionLabel>Subtotal</SubscriptionLabel>
              <SubscriptionAmount>Rs. 500</SubscriptionAmount>
            </SubscriptionRow>
            <SubscriptionRow>
              <SubscriptionTotalLabel>Total Amount</SubscriptionTotalLabel>
              <SubscriptionTotalAmount>Rs. 500</SubscriptionTotalAmount>
            </SubscriptionRow>
            <Button
              type="button"
              title="Proceed to pay"
              styleButton="width: 100%; height: 50px"
              onClick={handlePay}
            />
          </SubscriptionSummary>
        )}
      </SubscriptionContainer>
      <PopupToast
        isOpen={isPopupOpen}
        heading={
          verificationStatus === 'success' ? 'Congratulations!' : 'Failure !'
        }
        content={
          verificationStatus === 'success'
            ? 'Your subscription has been activated successfully.'
            : 'Your subscription failed. Please try again.'
        }
        buttonText="Go to Home Page"
        onClick={handleClickHome}
      />
    </>
  )
}

export default SubscriptionPage
